import script from "./UIIntroSteps.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIIntroSteps.vue?vue&type=script&lang=ts&setup=true"

import "./UIIntroSteps.vue?vue&type=style&index=0&id=6c4b40fa&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4b40fa"]])

export default __exports__